// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ZrHgHQ","closeContainer":"_qtK5k35","gamesContainer":"_qruV7eQ","header":"_2hBv1_I","gameList":"_3K0qp3P"};